import { array, Decoder, object, string } from '@mojotech/json-type-validation'

import { algorithmCategoryDecoder } from './algorithmCategoryDecoder'
import { problemCategoryDecoder } from './problemCategoryDecoder'
import { problemTagDecoder } from './problemTagDecoder'

import { ProblemAttachment } from '@/domain/entities/problem/problemAttachment'

export const problemAttachmentDecoder: Decoder<ProblemAttachment> = object({
  problemId: string(),
  recommendations: array(string()),
  bookmarks: array(string()),
  problemCategories: array(problemCategoryDecoder),
  algorithmCategories: array(algorithmCategoryDecoder),
  tags: array(problemTagDecoder)
})
